import { gql } from "@apollo/client";export default gql`mutation deleteMeme($id: Int!) {
    deleteMeme: delete_meme_by_pk(id: $id) {
        id
    }
}
`;
